
module.exports = {
	Home: {
        systemName: '管理系统',
		skinPeeler: '换肤',
		help: '帮助',
        language: '语言',
        Chinese: '中文',
        English: '英文',
        German: '德文',

        homePage: '首页',
        changePassword: '修改密码',
        signOut: '退出',
        goodMorning:'上午好',
        goodNoon: '中午好',
        goodAfternoon: '下午好',
        goodEvening: '晚上好'
	},
    Btn: {
        queryBtn: '查询',
        resetBtn: '重置',
        addBtn: '新增',
        editBtn: '编辑',
        deleteBtn: '删除',
        setPasswordBtn: '重置密码'
    },
    Label: {
        name: '姓名',
        loginName: '登录名',
        role: '角色',
        state: '状态',
        mobile: '手机号',
        type: '用户类型',
      roleType:'角色类型'
    },
    System: {
        inName: '请输入姓名',
        inLoginName: '请输入登录名',
        seRoles: '请选择角色',
        seStatus: '请选择用户状态',
        adQuery: '高级查询',
        basicQuery: '基本查询',
        queryCriteria: '查询条件',
        inMobile: '请输入手机号',
        inType: '请选择用户类型',
        inRoleType:'请选择角色类型'
    },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js